import {actions} from './actions';
import {
  armoniaTokenName,
  sessionRemoveData,
  sessionSaveData
} from "../../services/session-storage-management/session-storage-management";
import Cookies from "js-cookie";

/**
 *  Indentifico Reducer utilizzati dalla sezione Authorization
 */
const AuthorizationReducers = {
  [actions.AUTHORIZATION_SUCCESS]: (state,action) => { return { ...state, token: action.token, username: action.username, loggedIn: action.loggedIn, roles: action.roles }},
  [actions.AUTHORIZATION_ERROR]: (state, action) => { Cookies.remove(armoniaTokenName); return { ...state, token: action.token, username: action.username, loggedIn: action.loggedIn  }},
}

// da importare nel reducer principale per includerli nello store
export default AuthorizationReducers;
